import { ReactComponent as SaveIcon } from './save.svg';

export default SaveIcon;
